"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useControlMotionProps = void 0;
var _checkbox = require("@cbhq/cds-common/motion/checkbox");
var _useMotionProps = require("../motion/useMotionProps");
var _tokens = require("../tokens");
const useControlMotionProps = ({
  checked,
  shouldAnimateBackground = true,
  initialBackground = _tokens.palette.background
}) => {
  const outerContainerMotionProps = (0, _useMotionProps.useMotionProps)({
    variants: {
      enter: Object.assign({
        borderColor: _tokens.palette.primary
      }, shouldAnimateBackground ? {
        backgroundColor: _tokens.palette.primary
      } : {}),
      exit: Object.assign({
        borderColor: _tokens.palette.lineHeavy
      }, shouldAnimateBackground ? {
        backgroundColor: initialBackground
      } : {})
    },
    transition: {
      easing: 'enterFunctional',
      duration: 'moderate1'
    },
    animate: checked ? 'enter' : 'exit'
  });
  const innerContainerMotionProps = (0, _useMotionProps.useMotionProps)({
    enterConfigs: [_checkbox.checkboxOpacityEnterConfig, _checkbox.checkboxScaleEnterConfig],
    exitConfigs: [_checkbox.checkboxOpacityExitConfig, _checkbox.checkboxScaleExitConfig],
    animate: checked ? 'enter' : 'exit'
  });
  return {
    outerContainerMotionProps,
    innerContainerMotionProps
  };
};
exports.useControlMotionProps = useControlMotionProps;